import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import { Subscription } from 'rxjs';
import { TicketDto } from '../../../service/dto';
import { MainLayoutComponent } from '../../main-layout/main-layout.component';
import { PolicyStatusEnum } from '../../../service/dto-insurance';

@Component({
	selector: 'app-tickets-view-history',
	standalone: false,
	templateUrl: './tickets-view-history.component.html',
	styleUrl: './tickets-view-history.component.scss'
})
export class TicketsViewHistoryComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	ticket?: TicketDto;

	constructor(private route: ActivatedRoute, private httpService: HttpTicketService, private mainLayout: MainLayoutComponent) {

	}
	ngOnInit(): void {
		this.mainLayout.setHeadlessMode(true);
		this.subscription.add(this.route.paramMap.subscribe(paramMap => {
			this.httpService.get(+paramMap.get('ticketId')!).subscribe(result => this.ticket = result);
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}


	policyStatusColor(status: PolicyStatusEnum): string {
		switch (status) {
			case 'Active': return 'green';
			case 'Suspended': return 'red';
			case 'Ended': return 'grey';
			case 'Grace': return 'blue';
			case 'Lapsed': return 'red';
			default: return 'default';
		}
	}
}
